<template>
    <div>
        <EnergyAnalysis v-if="flag"/>
        <!-- 尖峰平谷 -->
        <PinnaclesFlat v-if="flag"/>
        <!-- 同环比 -->
        <SameCycleRatio v-if="flag"/>
        <!-- 折煤标 -->
        <FoldingSandard v-if="flag"/>
        <!-- 能耗用电排名 -->
        <EquipmentElectricity :sortArr="sortArr" v-if="flag"/>
        <!-- 月能耗占比 -->
        <MonEnergy v-if="flag"/>
    </div>
</template>

<script>
    const PinnaclesFlat = () => import("./components/PinnaclesFlat.vue")
    const EnergyAnalysis = () => import("./components/EnergyAnalysis")
    const FoldingSandard = () => import("./components/FoldingSandard")
    const SameCycleRatio = () => import("./components/SameCycleRatio.vue")
    const EquipmentElectricity = () => import("./components/EquipmentElectricity.vue")
    const MonEnergy = () => import("./components/MonEnergy.vue")

    export default {
        name: "Consumption",
        props:{
            selectBuildId:String,
            arrEnergy:{
                type:Array,
                default:[]
            }
        },
        components: {
            EnergyAnalysis,
            PinnaclesFlat,
            FoldingSandard,
            SameCycleRatio,
            EquipmentElectricity,
            MonEnergy
        },
        data() {
            return {
                sortArr:[], // 所有能耗排名数组
                flag:false
            };
        },
        mounted() {
            console.log(this.selectBuildId);
            this.sortingArr()
        },
        activated(){
            console.log('激活能耗');
            console.log(this.selectBuildId);
            this.flag = true
        },
        deactivated(){
            console.log('失活能耗');
            this.flag = false
        },
        methods: {
            // 处理数组 
            sortingArr(){
                if(this.arrEnergy.length >0){
                    
                    let arr = this.arrEnergy.map((item, index)=>{
                        let max = item[0].itemPower
                        return item.map((val, key)=>{
                            let width = Math.floor(val.itemPower / max * 100) 
                            let color = '#'+('00000'+ (Math.random()*0x1000000<<0).toString(16)).substr(-6); 
                            return {
                                title:val.title,
                                id:val.id,
                                ratioStyle:{
                                    width:`${width}%` ,
                                    background: color
                                },
                                val:val.itemPower
                            }    
                        })
                    })
                    this.sortArr = arr
                    console.log(this.sortArr);
                }
            },
        },
    };
</script>

<style lang="less" scoped>
   

    .menuButtons{
        width: 10vw;
        height: 7vh;
        position: fixed;
        top: 6.8vh;
        left: 22.5vw;
        display: flex;
        flex-direction: row;
    }

    .posAlarm{
        width: 20.8vw;
        position: fixed;
        top: 8vh;
        border-radius: 4px;
        right: 22vw;
        background: linear-gradient(0deg, rgba(0, 33, 59, 0.8) 0%, rgba(3, 13, 24, 0.8) 100%);
        box-shadow: 
            0 0 16rem 0 #FF5555, 
            0 0 16rem 0 #FF5555;
        padding: 0 5rem;
        .alarmEvents{
            width: 100%;
            padding: 0 15rem;
            max-height: 92vh;
            overflow-x:hidden ;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgba(255, 255, 255, 0.7);
                border-radius: 2rem;
            }
            .alarmEvent{
                height: 7.87vh;
                width: 95%;
                .atop{
                    padding-top: 1.4vh;
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    position: relative;
                    .img{
                        width: 2.6vh;
                        height: 2.6vh;
                        vertical-align: middle;
                        margin-top: 0.4vh;
                        display: inline-block;
                        background: url('../../../assets/img/r.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .eventName{
                        display: inline-block;
                        text-shadow: 
                        0 0 1vh  #de5962,
                        0 0 2vh  #de5962,
                        0 0 3vh  #de5962;
                    }
                    span{
                        position: absolute;
                        right: 0;
                        top: 2vh;
                        font-size: 14rem;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                    }
                    img:nth-of-type(1){
                        width: 16rem;
                        height: 16rem;
                        position: absolute;
                        top: 2.1vh;
                        right: -2.7vh;
                    }
                }
                .abottom{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    padding-left: 1.3vw;
                    padding-top: 0.2vh;
                    position: relative;
                    .con{
                        width: 14vw; 
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    img{
                        width: 0.7vw;
                        height: 1.7vh;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
                
            }
            
        }
    }
    .yellowAlarm{
        box-shadow: 
            0 0 16rem 0 #F5AA00, 
            0 0 16rem 0 #F5AA00;  
            .alarmEvents{
                .alarmEvent{
                    .atop{
                        .img{
                            background: url('../../../assets/img/y.png') no-repeat;
                        }
                        .eventName{  
                            text-shadow: 
                                0 0 1vh  #F5AA00,
                                0 0 2vh  #F5AA00,
                                0 0 3vh  #F5AA00;
                        }
                    }
                }
            }
            
    }
    .blueAlarm{
        box-shadow: 
            0 0 16rem 0 #0D94FF, 
            0 0 16rem 0 #0D94FF;
            .alarmEvents{
                .alarmEvent{
                    .atop{
                        .img{
                            background: url('../../../assets/img/b.png') no-repeat;
                        }
                        .eventName{  
                            text-shadow: 
                                0 0 1vh  #0D94FF,
                                0 0 2vh  #0D94FF,
                                0 0 3vh  #0D94FF;
                        }
                    }
                }
            }
    }

    .alarm-enter,
    .alarm-leave-to {
        top: 0,
    }

    .alarm-enter-active,
    .alarm-leave-active {
        transition: top 1s
    }

    .posAlarms{
        width: 20.8vw;
        position: fixed;
        top: 8vh;
        border-radius: 4px;
        right: 22vw;
        background: linear-gradient(0deg, rgba(0, 33, 59, 0.85) 0%, rgba(3, 13, 24, 0.9) 100%);
        padding: 0 5rem;
        .alarmEventss{
            width: 100%;
            padding: 0 15rem;
            max-height: 92vh;
            overflow-x:hidden ;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgba(255, 255, 255, 0.7);
                border-radius: 2rem;
            }
            .alarmEvents{
                height: 7.87vh;
                width: 100%;
                border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                .atops{
                    padding-top: 1.4vh;
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    position: relative;
                    img{
                        width: 2.6vh;
                        height: 2.6vh;
                        vertical-align: middle;
                    }
                    span{
                        position: absolute;
                        right: 0;
                        top: 2vh;
                        font-size: 14rem;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                    }
                }
                .abottoms{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    padding-left: 1.7vw;
                    padding-top: 0.2vh;
                    position: relative;
                    .cons{
                        width: 14vw; 
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    img{
                        width: 0.7vw;
                        height: 1.7vh;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
            }

            .noneEvent{
                height: 3vh;
                line-height: 3vh;
                font-size: 16rem;
                text-align: center;
                color: #FFFFFF;
            }
        }
    }
</style>